import { buttonWithPrefixSuffixIcon } from '../icons';
import { DEFAULT_CSS_CLASS } from '@constants';

const defaultBlockCssClass = DEFAULT_CSS_CLASS.BUTTON;

const prefixIconAndSuffixIcon = {
  name: 'button-with-prefix icon-and-title-and-suffix icon',
  title: 'Button with Prefix Icon and Suffix Icon',
  icon: buttonWithPrefixSuffixIcon,
  scope: ['block'],
  attributes: {
    blockClassNames: [
      {
        value: `${defaultBlockCssClass}--primary`,
        label: 'Primary',
      },
    ],
  },
  innerBlocks: [
    [
      'b3rg/span',
      {
        blockClassNames: [
          { value: `${defaultBlockCssClass}__p`, label: 'Prefix' },
        ],
      },
      [['b3rg/icon-block']],
    ],
    [
      'core/paragraph',
      {
        className: 'title',
        content: 'Button Title',
        placeholder: 'Add Button Title',
      },
    ],
    [
      'b3rg/span',
      {
        blockClassNames: [
          { value: `${defaultBlockCssClass}__s`, label: 'Suffix' },
        ],
      },
      [['b3rg/icon-block']],
    ],
  ],
};

export default prefixIconAndSuffixIcon;
